import { Arrange, Skeleton } from "@aviary";

const SkeletonCart = () => {
  return (
    <Arrange isVertical isFullWidth>
      <Skeleton type="typography" typographySize="h5" isFullWidth />
      <Skeleton type="typography" typographySize="h5" isFullWidth />
      <Skeleton type="typography" typographySize="h5" isFullWidth />
      <Skeleton type="typography" typographySize="h5" isFullWidth />
    </Arrange>
  );
};

export { SkeletonCart };
